import { z } from 'zod';

import locales from 'common/zod/locales';

import { fiscalIdFormSchema } from './fiscalIdForm.schema';

export const generalContentFormSchema = z.object({
  clientId: z.string().trim().min(1, { message: locales.errors.required }),
  fiscalId: fiscalIdFormSchema,
  startAt: z.number(),
  subtitle: z.string().trim().nullable(),
  title: z.string().trim().min(1, { message: locales.errors.required }),
});

export type GeneralContentFormSchema = z.infer<typeof generalContentFormSchema>;

export const hiddenGeneralContentFormSchema = z.object({
  companyProfileId: z.string(),
  currency: z.string(),
  lastEditedAt: z.number().optional(), // needed for caching
});

export type HiddenGeneralContentFormSchema = z.infer<
  typeof hiddenGeneralContentFormSchema
>;
